import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CorrelationIdStore {
  getNewCorrelationId(): string {
    return this.generateCorrelationId();
  }

  private generateCorrelationId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
      const random = Math.floor(Math.random() * 16);
      const value = char === 'x' ? random : ((random & 0x3) | 0x8);
      return value.toString(16);
    });
  }
}
